import { cinzel } from '@/lib/brand-font'

// Internal build number — stays an INTEGER because deploy.sh greps it to tag
// the Docker image (omnex-x:v490) and sw.js uses it for cache names. Do not
// change its type/format.
export const APP_VERSION = 785

// Professional display label derived from the build number: 490 → "V4.90".
export function formatVersion(n: number = APP_VERSION): string {
  return `V${(n / 100).toFixed(2)}`
}

export default function SidebarLogo() {
  return (
    <div className="sidebar-logo">
      <span className={`sidebar-logo-text ${cinzel.className}`}>OMNEX</span>
      <span className="sidebar-logo-version">{formatVersion()}</span>

      <style jsx>{`
        .sidebar-logo {
          display: flex;
          align-items: baseline;
          gap: 6px;
          padding: 0 16px;
          margin-bottom: 4px;
        }

        .sidebar-logo-text {
          font-size: 16px;
          font-weight: 700;
          color: var(--gold);
          letter-spacing: 0.08em;
        }

        .sidebar-logo-version {
          font-size: 10px;
          color: var(--t3);
        }
      `}</style>
    </div>
  )
}
